import ApiService from "../util/api.service";
import { SERVICE_CONFIG_URLS } from "./config";

async function contactUs(payload) {
    const response = await ApiService.post(
        SERVICE_CONFIG_URLS.CONTACTUS.CONTACT,
        payload
    );
    return response;
}

const contactService = {
    contactUs,
};

export default contactService;
